class App {
    constructor() {
        this.datas = [];
    }

    footer_event() {
    }

    gnav() {
        $('.gsnav').on('click', function () {
            $('.menu-trigger', this).toggleClass('active');
            $('header .header-nav').toggleClass('active');
            return false;
        });
    }

    home_video_size() {
        var winH = $(window).height();
        let area = $('.movie');
        let video = $('.movie video');
        area.outerHeight(winH);
        $(window).on('load', function () {
            setBgImg(video);
        });

        $(window).on('resize', function () {
            winH = $(window).height();
            area.outerHeight(winH);
            setBgImg(video);
        });

        function setBgImg(object) {
            // 画像サイズ取得
            var imgW = object.width();
            var imgH = object.height();

            // ウィンドウサイズ取得
            var winW = $(window).width();
            var winH = $(window).height();

            // 幅・高さの拡大率取得
            var scaleW = winW / imgW;
            var scaleH = winH / imgH;

            // 幅・高さの拡大率の大きいものを取得
            var fixScale = Math.max(scaleW, scaleH);

            // 画像の幅高さを設定
            var setW = imgW * fixScale;
            var setH = imgH * fixScale;

            // 画像の位置を設定
            var moveX = Math.floor((winW - setW) / 2);
            var moveY = Math.floor((winH - setH) / 2);

            // 設定した数値でスタイルを適用
            object.css({
                'width': setW,
                'height': setH,
                'left': moveX,
                'top': moveY,
            });
            area.addClass('on');
        }
    }

    init() {
        const _self = this;
        _self.home_video_size();
        _self.gnav();
    }
}
class ScrollAddClass {
    // 初期値を設定
    constructor() {
        this.controller = new ScrollMagic.Controller();
        this.settings = {
            target: '.js-scrollAnimation', // アニメーションさせたい要素
            addClassName: 'animated', // アニメーションさせたい要素に付与するclass
            triggerHook: 'onEnter', // 発火タイミング：画面下"onEnter"、画面中央"onCenter"、画面上"onLeave""
            offset: 100, // 100だと100px早く発火-100だと-100px遅く発火
        };
    }

    // 実行
    init(options) {
        // this.setup(options);
        this.attachEvent(this.controller);
    }

    // ScrollMagicを実行
    attachEvent(controller) {
        let targets = document.querySelectorAll(this.settings.target);
        if (targets.length == 0) {
            return;
        }
        for (let target of targets) {
            let scene = new ScrollMagic.Scene({
                triggerElement: target,
                triggerHook: this.settings.triggerHook,
                offset: this.settings.offset,
            })
            .addTo(controller);

            scene.on('enter', () => {
                target.classList.add(this.settings.addClassName);
            });
        }
    }
}
let app = new App();
$(function () {
    app.init();
    let scrollAnimation = new ScrollAddClass();
    scrollAnimation.init();
});

$(window).on('load', function () {
    // app.footer_event();
});
